// @ts-nocheck
// this is not preferred when using TS but as this is just an example, we are
// using it to avoid need to convert styles/media-queries to TS
import styled from 'styled-components';

import {
  Button,
  Headline,
  Eyebrow as EyebrowComponent,
} from 'components/atoms';
import { minWidth } from 'styles/media-queries';
import { spacer8, spacer16, spacer24, spacer5 } from 'styles/spacers';
import { black, white, white20OpacityOnBlack } from 'styles/colors';

// Styled components
export const TaggedContentTile = styled.div`
  border-radius: 8px;
  ${props => props.onClick && `cursor: pointer;`}
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.textColor};
  aspect-ratio: ${props => (props.theme.wide ? '4 / 8' : '4 / 5')};

  ${minWidth.lg`
    ${props =>
      props.theme.wide
        ? `
        aspect-ratio: 8 / 5;
        flex-direction: row;
        grid-column: span 2;
      `
        : `
        aspect-ratio: 4 / 5;
        grid-column: span 1;
    `}
  `}

  cursor: pointer;

  &:hover .button-arrow {
    background-color: ${white20OpacityOnBlack};
    svg {
      path {
        fill: ${white};
      }
    }
  }
`;

export const TopContainer = styled.div`
  padding: ${spacer16};
  gap: ${spacer16};
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  ${props =>
    props['data-src']
      ? `background-image: url(${props['data-src']}); background-size: cover; background-position: center; background-repeat: no-repeat;`
      : `background-color: ${props.theme.backgroundColor}; display: flex; padding: ${spacer24};`}
`;

export const Eyebrow = styled(EyebrowComponent)`
  width: max-content;
  padding: 1.2rem ${spacer24};
  border-radius: ${spacer5};
  background-color: ${white};
  color: ${black};
`;

export const StatTitle = styled(Headline)`
  ${minWidth.md`
    font-size: 8rem;
  `}
  ${minWidth.lg`
    font-size: 10rem;
  `}
  ${minWidth.xl`
    font-size: 12rem;
  `}
`;

export const BottomContainer = styled.div`
  background-color: ${props => props.theme.backgroundColor};
  padding: ${spacer24};
  display: flex;
  flex-direction: column;
  gap: ${spacer16};
`;

export const ButtonCta = styled(Button)`
  &.button-arrow {
    background-color: ${white};
    path {
      fill: ${black};
    }
  }
`;

export const LeftContainer = styled.div`
  ${minWidth.lg`
    width: 50%;
  `}
  display: flex;
  flex-direction: column;
`;

export const RightContainer = styled.div`
  ${minWidth.lg`
    width: 50%;
  `}
  height: 100%;
  padding: ${spacer24};
`;

export const ImageContainer = styled.div`
  height: 100%;
  width: 100%;
  border-radius: ${spacer8};
  ${props =>
    props['data-src'] &&
    `background-image: url(${props['data-src']}); background-size: cover; background-position: center; background-repeat: no-repeat;`}
`;

export const FlipContainer = styled.div`
  perspective: 1000px;
  position: relative;
`;

export const FlippableTaggedContentTile = styled(TaggedContentTile)`
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: relative;
`;

export const FlipFace = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.6s;
  transform-style: preserve-3d;
`;

export const FlipFront = styled(FlipFace)`
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.textColor};
  transform: ${props =>
    props.theme.isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'};
`;

export const FlipBack = styled(FlipFace)`
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.textColor};
  transform: ${props =>
    props.theme.isFlipped ? 'rotateY(0deg)' : 'rotateY(180deg)'};
  .button-arrow {
    transform: scaleX(-1);
  }
`;
